import { upsertExportJob } from 'components/practice/Export/ExportDockCard/lib/upsertExportJob';

// `export-progress` socket channel handler. The forward-only merge, dismissed-skip,
// dock open, and query invalidation all live in the shared write path.
export default (data) => upsertExportJob(data);
